import { render, staticRenderFns } from "./TheSnapshotTableColDescriptionEdit.vue?vue&type=template&id=63d9eb98&"
import script from "./TheSnapshotTableColDescriptionEdit.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotTableColDescriptionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports